module.exports = __webpack_public_path__ + "media/images/lb/565-171cb4f5ee0fcfcaef3e3481ea18bb9b.svg";